export const ANALYTICS_BI_EVENT = 'ANALYTICS_BI_EVENT'

export const analyticsBiEvent = () => ({
  type: ANALYTICS_BI_EVENT,
})

export const ANALYTICS_PAGE_VIEW_EVENT = 'ANALYTICS_PAGE_VIEW_EVENT'

export const analyticsPageViewEvent = (payload) => ({
  type: ANALYTICS_PAGE_VIEW_EVENT,
  payload,
})
